module.exports = __webpack_public_path__ + "img/texture-map2.30af7523.png";